import { useEffect, useState, type ReactNode } from "react";

import { SkipEntranceContext } from "./skip-entrance-context";

/** Anything that mounts with the provider, e.g. after a reload, renders in its final state instead of animating in. */
export const SkipEntranceProvider = ({ children }: { children: ReactNode }) => {
  const [skip, setSkip] = useState(true);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setSkip(false));
    return () => cancelAnimationFrame(frame);
  }, []);

  return <SkipEntranceContext.Provider value={skip}>{children}</SkipEntranceContext.Provider>;
};
